<template>
  <PageLayout
    :title="title"
    :subtitle="subtitle"
    :stack-filters-below-title="stackFiltersBelowTitle"
  >
    <template v-if="$slots.title" #title>
      <slot name="title" />
    </template>
    <template v-if="$slots.subtitle" #subtitle>
      <slot name="subtitle" />
    </template>
    <template v-if="$slots['title-extra']" #title-extra>
      <slot name="title-extra" />
    </template>
    <template v-if="$slots.actions" #actions>
      <slot name="actions" />
    </template>
    <template v-if="$slots.search" #search>
      <slot name="search" />
    </template>
    <template v-if="$slots.filters" #filters>
      <slot name="filters" />
    </template>
    <template v-if="$slots.toolbar" #toolbar>
      <slot name="toolbar" />
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from "./PageLayout.vue";

export default {
  name: "PageContentHeader",
  components: { PageLayout },
  inheritAttrs: false,
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    stackFiltersBelowTitle: { type: Boolean, default: undefined },
  },
};
</script>
